import React from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import { commonErr } from "../common/errors";
import Session from "../common/session";
import Header from "../components/header";
import Footer from "../components/footer";
import { MessageBox } from "../common/messagebox";
// CAR HEADER
import CarSettingHeader from "./carsettingheader";
// CAR SLIDE BAR
import CarSettingSideBar from "./carsettingsidebar";
import CarSettingSideBarMobile from "./carsettingsidebarmobile";

// common
import CarSettingInfo from "./carsettinginfo";
import CarSettingPhotos from "./carsettingphotos";
import CarSettingPapers from "./carsettingpapers";
import CarSettingGPS from "./carsettinggps";
import CarSettingTrips from "./carsettingtrips";
import CarSettingRentingTime from "./carsettingrentingtime";

// with driver
import { CarSettingDeliveryWD, CarSettingPoliciesWD } from "./carsettingrentingwd";
import CarSettingPriceWD from "./carsettingpricewd";
import CarSettingCalendarWD from "./carsettingcalendarwd";

// self drive
import CarSettingRenting from "./carsettingrenting";
import CarSettingCalendar from "./carsettingcalendar";
import CarSettingPrice from "./carsettingprice";
import CarSettingDelivery from "./carsettingdelivery";
import CarSettingExtraFee from "./carsettingextrafee";

// MODEL CALL API
import { getCarDetail, getOwnerCars, getCarSetting, updateCar } from "../../model/car";
import { stypes } from "../common/common";

class CarSetting extends React.Component {
	constructor(props) {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			handler: "",
			isShowMenuSd: false,
			isShowMenuWd: false,
		};
	}

	componentDidMount() {
		const carId = this.props.match.params.carId;
		getCarDetail(carId).then((carDetailResp) => {
			if (carDetailResp.data.error >= commonErr.SUCCESS && carDetailResp.data.data.car) {
				getOwnerCars(0, 0, 0, 0, true).then((carOwnerResp) => {
					if (carOwnerResp.data.error >= commonErr.SUCCESS && carOwnerResp.data.data.cars) {
						this.setState({
							cars: carOwnerResp.data.data.cars, //all cars list of user
							car: carDetailResp.data.data.car, //value of 1 car by carid
						});
					} else {
						this.setState({
							err: carOwnerResp.data.error,
						});
					}
				});
			} else {
				this.setState({
					err: carDetailResp.data.error,
				});
			}
		});

		getCarSetting({ carId: carId }).then((carSettingResp) => {
			if (carSettingResp.data.error >= commonErr.SUCCESS) {
				const papers = carSettingResp.data.data.papers;
				if (papers) {
					this.setState({ reddot: this.hasRedDot(papers) }); //red dot in slide bar
				}
			} else {
				this.setState({
					err: carSettingResp.data.error,
				});
			}
		});
	}

	componentWillReceiveProps(props) {
		const carId = props.match.params.carId;
		if (carId !== this.props.match.params.carId) {
			this.getCar(carId);
		}
	}

	getCar = (carId = this.props.match.params.carId) => {
		getCarDetail(carId).then((carDetailResp) => {
			if (carDetailResp.data.error >= commonErr.SUCCESS && carDetailResp.data.data.car) {
				this.setState({
					car: carDetailResp.data.data.car,
				});
			} else {
				this.setState({
					err: carDetailResp.data.error,
				});
			}
		});
	};

	hasRedDot = (papers) => {
		if (papers === undefined) {
			return true;
		}
		for (var i = 0; i < papers.length; i++) {
			if (papers[i].photos === undefined) {
				return true;
			}
			if (papers[i].photos.length < 1) {
				return true;
			}
		}
		return false;
	};

	onRentingModeChange = (event) => {
		const value = event.target.checked; //type checkbox
		const name = event.target.name;
		const carId = this.props.match.params.carId;
		const { car } = this.state;
		// Pause register
		if (car.timeApprovedWD === 0 && name === "withDriver" && value) {
			this.setState({
				errMsg: (
					<React.Fragment>
						<div>Không bật được chế độ xe có tài xế.</div>
						<div>
							Mioto tạm thời dừng tính năng ĐĂNG KÍ MỚI CHỦ XE "CÓ TÀI XẾ" vì đã đủ số lượng xe đăng kí. (dự kiến sẽ
							kích hoạt lại trong 09/2020, Mioto sẽ thông báo đến Quý đối tác qua ứng dụng Mioto trong thời gian sớm
							nhất. Xin cám ơn sự ủng hộ từ Quý đối tác)
						</div>
					</React.Fragment>
				),
			});
			return;
		}

		if ((car.wd && car.sd) || value) {
			//for at least 1 selected
			updateCar(carId, { [name]: value }).then((updateCarResp) => {
				if (updateCarResp.data.error >= commonErr.SUCCESS) {
					this.getCar();
				}
			});
		} else {
			this.setState({
				errMsg: " Không thể tắt hết các chế độ cho thuê",
			});
		}
	};

	toggleSdSettingMobile = () => {
		this.setState({
			isShowMenuSd: !this.state.isShowMenuSd,
		});
	};

	closeSdSettingMobile = () => {
		this.setState({
			isShowMenuSd: false,
		});
	};

	toggleWdSettingMobile = () => {
		this.setState({
			isShowMenuWd: !this.state.isShowMenuWd,
		});
	};

	closeWdSettingMobile = () => {
		this.setState({
			isShowMenuWd: false,
		});
	};

	hideMessageBox = () => {
		this.setState({
			errMsg: "",
		});
	};

	render() {
		const carId = this.props.match.params.carId;
		const handler = this.props.location.hash;

		const { cars, car, reddot } = this.state;
		const profile = this.props.session.profile.info;

		var content;
		if (profile && profile.uid) {
			if (car) {
				switch (handler) {
					// common
					case "#infosetting":
						content = <CarSettingInfo car={car} />;
						break;
					case "#photossetting":
						content = <CarSettingPhotos car={car} />;
						break;
					case "#paperssetting":
						content = <CarSettingPapers car={car} />;
						break;
					case "#gpssetting":
						content = <CarSettingGPS car={car} />;
						break;
					case "#tripssetting":
						content = <CarSettingTrips car={car} />;
						break;

					// with driver
					case "#wddeliverysetting":
						content = <CarSettingDeliveryWD car={car} />;
						break;
					case "#wdpricesetting":
						content = <CarSettingPriceWD car={car} />;
						break;
					case "#wdcalendarsetting":
						content = <CarSettingCalendarWD car={car} />;
						break;
					case "#wdpoliciessetting":
						content = <CarSettingPoliciesWD car={car} />;
						break;
					case "#wdrentingtimesetting":
						content = <CarSettingRentingTime stype={stypes.WD} car={car} />;
						break;

					// self drive
					case "#deliverysetting":
						content = <CarSettingDelivery car={car} />;
						break;

					case "#calendarsetting":
						content = <CarSettingCalendar car={car} />;
						break;

					case "#pricesetting":
						content = <CarSettingPrice car={car} />;
						break;

					case "#policiessetting":
						content = <CarSettingRenting car={car} />;
						break;
					case "#rentingtimesetting":
						content = <CarSettingRentingTime stype={stypes.SD} car={car} />;
						break;
					case "#extrafee":
						content = <CarSettingExtraFee car={car} />;
						break;
					// default switch
					default:
						content = <CarSettingInfo car={car} />;
				}
			}
		}

		return (
			<div canvas="container">
				<div className="mioto-layout">
					<MessageBox
						error={this.state.err}
						message={this.state.errMsg}
						show={this.state.errMsg && this.state.errMsg !== ""}
						hideModal={this.hideMessageBox.bind(this)}
					/>
					<Session />
					<Header />
					<section className="body">
						{car && (
							<CarSettingSideBarMobile
								car={car}
								carId={carId}
								handler={handler}
								reddot={reddot}
								isShowMenuSd={this.state.isShowMenuSd}
								toggleSdSetting={this.toggleSdSettingMobile}
								closeSdSetting={this.closeSdSettingMobile}
								isShowMenuWd={this.state.isShowMenuWd}
								toggleWdSetting={this.toggleWdSettingMobile}
								closeWdSetting={this.closeWdSettingMobile}
							/>
						)}

						{car && cars && (
							<CarSettingHeader
								car={car}
								cars={cars}
								getCar={this.getCar.bind(this)}
								onRentingModeChange={this.onRentingModeChange.bind(this)}
							/>
						)}

						<div className="body-container settings min-height-no-footer">
							{car && (
								<CarSettingSideBar
									car={car}
									carId={carId}
									handler={handler}
									reddot={reddot}
									onRentingModeChange={this.onRentingModeChange}
								/>
							)}
							{content}
							<div className="clear"></div>
						</div>
					</section>
					<Footer />
				</div>
			</div>
		);
	}
}

function mapState(state) {
	return {
		session: state.session,
	};
}

CarSetting = connect(mapState)(CarSetting);

export default CarSetting;
